import { AlertBox, Link, Button } from '@vp/swan';
import React, { useContext, useEffect, useCallback } from 'react';
import { CONVERSATION_CONSTANTS } from './src-config-miaw-constants.js';
import { CAContext } from './src-contexts-CAContext.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { MiawChatContext } from './src-contexts-MiawChatContext.js';
import { useMIAWAgentActions } from './src-hooks-miaw-useMIAWAgentActions.js';
import { clearInMemoryData } from './src-utils-miaw-chat-config.js';
import { clearChatbotToken, clearChatSessionType, clearRestId } from './src-utils-session-storage-utils.js';

const ErrorMessage = () => {
  const [message, setMessage] = React.useState();
  const { handleCloseEventSource } = useMIAWAgentActions();
  const { setChatState } = useContext(CAContext);
  const {
    state: { showErrorMessage },
    setState: setChatbotState
  } = useContext(ChatbotContext);
  const {
    state: { isMIAWApiError },
    setState: setMIAWContext
  } = useContext(MiawChatContext);
  useEffect(() => {
    if (showErrorMessage) {
      setMessage(`We're having trouble connecting to Vista Assistant.`);
    } else if (isMIAWApiError) {
      setMessage(`We're having trouble connecting to Chat`);
    } else {
      setMessage("Something went wrong");
    }
  }, [showErrorMessage, isMIAWApiError]);
  const handleRefresh = useCallback(() => {
    if (showErrorMessage) {
      setChatbotState((prevState) => ({
        ...prevState,
        conversationMessages: [],
        discussionId: "",
        sessionId: "",
        showErrorMessage: false
      }));
      clearChatbotToken();
      clearChatSessionType();
      clearRestId();
    } else if (isMIAWApiError) {
      handleCloseEventSource();
      setMIAWContext((prevState) => ({
        ...prevState,
        conversationMessages: [],
        conversationId: "",
        agentName: "",
        conversationStatus: CONVERSATION_CONSTANTS.ConversationStatus.NOT_STARTED_CONVERSATION
      }));
      clearInMemoryData();
      setChatbotState((prevState) => ({
        ...prevState,
        conversationMessages: [],
        discussionId: "",
        sessionId: ""
      }));
      clearChatbotToken();
      clearRestId();
      clearChatSessionType();
    }
    setChatState((prevState) => ({
      ...prevState,
      // chatWindow: 'minimized',
      chatSession: "initial",
      isPrivacyPolicyAccepted: false
    }));
  }, []);
  return /* @__PURE__ */ React.createElement(AlertBox, { skin: "error", m: 5, style: { width: "initial" } }, message, " ", /* @__PURE__ */ React.createElement(
    Link,
    {
      render: (p) => /* @__PURE__ */ React.createElement(Button, { skin: "link", className: p.className, onClick: handleRefresh }, p.children)
    },
    "Refresh to try again."
  ));
};

export { ErrorMessage as default };
//# sourceMappingURL=src-components-ErrorMessage-ErrorMessage.js.map
